<template>
    <div class="ui-facebook-user-card" >
        <div>
            <div v-if="data && data.name" class="ui-facebook-user-card-title">{{ data.name }}</div>
            <div v-if="data && data.email" class="ui-facebook-user-card-subtitle">{{ data.email }}</div>
        </div>

        <ui-button v-if="data" design="sm mw-100 line-success" @click="disconnect">Desconectar</ui-button>
    </div> 
</template>

<script>
    import { uiButton } from "@/components/ui/buttons"

    export default {
        components: {
            uiButton
        },

        props: {
            data: {
                type: Object,
                required: true,
                default() {
                    return {}
                }
            },
            qtdAccounts: {
                type: Number,
                default: null
            }
        },

        created() {
            this.$root.$on('marketing-integrations-facebook-account-now-disconnect-success', () => {
                this.$root.$emit('datatable-reload-scroll-facebook')
                this.$root.$emit('disconnected-account')
            })

            this.$root.$on('marketing-integrations-facebook-account-disconnect-success', () => {
                this.$root.$emit("atualize-accounts")
            })
        },

        beforeDestroy() {
            this.$root.$off('marketing-integrations-facebook-account-now-disconnect-success')
            this.$root.$off('marketing-integrations-facebook-account-disconnect-success')
        },

        methods: {
            /**
             * Abre o modal de confirmação para desconectar conta
             */
            showFacebookAccountDisconnect() {
                this.$root.$emit('modal-msg-open-marketing-integrations-facebook-account-now-disconnect', {
                    method: 'delete',
                    id: this.data.id,
                    url: '',
                    formdata: {},
                    title: `A conta ${this.data.name} sera desconectada`,
                    eventSuccess: 'marketing-integrations-facebook-account-now-disconnect-success',
                    eventClose: 'marketing-integrations-facebook-account-now-disconnect-cancel'
                })
            },
            /**
             * Desconecta a conta e caso possua integrações solicita uma transferência
             */
            disconnect() {
                if (this.data && this.data.forms && this.data.forms.length > 0) {
                    if (this.qtdAccounts === 1) {
                        this.$root.$emit('alert-msg-open-facebook-account-not-existe-outer-message')

                    } else {
                        this.$root.$emit('modal-toggle-marketing-integrations-facebook-user-select')
                        this.$root.$emit('transfer-account', this.data)
                    }

                } else {
                    this.showFacebookAccountDisconnect()
                }
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>